import "./InviteLink.scss"
import React from "react"
import { authStore } from "../stores"
import { observer } from "mobx-react"
import { ASSESS_TYPE_TEAM } from "../constants"

const InviteLink = () => {
  if (!authStore.auth) {
    return null
  }
  return (
    <div className="InviteLink">
      <p>
        Email this link to the church leaders you'd like to invite to
        participate. They'll be able to take the opinion portion of the
        assessment, and their responses will be added to your church's
        dashboard.
      </p>
      <p>
        Give them a deadline to submit their answers, and then log back into
        your dashboard after that date to view your updated results!
      </p>
      <p>
        <i>Note: Responses submitted by your team will remain anonymous.</i>
      </p>
      <textarea
        value={`https://assess.theunstuckchurch.com/assess/${ASSESS_TYPE_TEAM}?church=${
          authStore.auth.uid
        }`}
        onFocus={e => e.target.select()}
        readOnly
      />
    </div>
  )
}

InviteLink.displayName = "InviteLink"

export default observer(InviteLink)



// WEBPACK FOOTER //
// ./src/dash/InviteLink.js